<template>
  <div>
    <div class="contact">
      <div>
        <div class="conact-header-image">
          <img :src="kefuImage" class="conact-image" />
        </div>
        <div class="tip">扫描图片，添加客服微信</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      kefuImage:
        "http://api-shop-image-bucket.oss-cn-shanghai.aliyuncs.com/upload/image/home/service1.png"
    };
  },
  methods: {}
};
</script>

<style scoped>
.contact {
  padding-top: 25%;
}

.tip {
  text-align: center;
  font-size: 12px;
  color: #666666;
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.conact-header-image {
  height: 140px;
  width: 140px;
  margin: 0 auto;
}

.conact-image {
  width: 140px;
  height: 140px;
}
</style>
